<template>
  <UPopover :ui="{
    background: '!overflow-visible',
    base: 'focus:outline-none',
  }">
    <MailEditorMenuButton :item="item" :style="{
      color: item.isActive ? `${displayColor(editor.getAttributes('textStyle')?.color)} !important` : undefined
    }" />
    <template #panel>
      <div class="p-2 flex flex-col gap-2">
        <MailBlockSettingBaseColor :fields="fields" :model-value="editor.getAttributes('textStyle')?.color"
          @update:model-value="updateColor" />
      </div>
    </template>
  </UPopover>
</template>

<script lang="ts" setup>
import { Editor } from "@tiptap/vue-3";
import type { FieldDefinition } from "~/models/Automation";
import type { MenuGroupItem } from "~/components/mail/EditorMenu.vue";

const { editor, fields = [], item } = defineProps<{
  editor: Editor
  fields?: FieldDefinition[];
  item: MenuGroupItem;
}>();

const emit = defineEmits(['action']);

function updateColor(color: string) {
  editor.chain().focus().setColor(color).run();
  emit('action');
  console.log(color);
}

function displayColor(color: string) {
  if (color?.startsWith('{{')) {
    return createFieldCollection(fields).replaceContent(color);
  }

  return color;
}
</script>
